export class ReportedLocation {
  constructor (place) {
    console.log('build location from:', place)

    if (place.place_id === undefined) {
      throw new Error('location input is missing attribute: place_id')
    }

    for (let attribute of ['place_id', 'url', 'name', 'formatted_address']) {
      if (place[attribute] !== undefined) {
        this[attribute] = place[attribute]
      }
    }

    if (typeof place.geometry.location.lat === 'function') {
      this.lat = place.geometry.location.lat()
      this.lng = place.geometry.location.lng()
    } else {
      this.lat = place.geometry.location.lat
      this.lng = place.geometry.location.lng
    }

    for (let attribute of ['lat', 'lng']) {
      if (this[attribute] === undefined) {
        throw new Error(`input has invalid attribute: ${attribute}`)
      }
    }
    console.log('constructed ReportedLocation:', this)
  }

  position () {
    return {
      lat: this.lat,
      lng: this.lng
    }
  }

  marker () {
    return {
      name: this.name,
      url: this.url,
      lat: this.lat,
      lng: this.lng
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/reported_location.js